module.exports = __webpack_public_path__ + "static/media/EX_FINISHED_alt_6.63abe623.mp3";